<template>
  <div class="stat-item">
    <!-- The icon sits in a badge tinted with the item's material colour so it
         doubles as the pie's colour key — no separate dot. (The icon is a remote
         image and can't be recoloured client-side, so we colour the surround
         instead.) -->
    <span
      class="item-icon"
      :style="{ backgroundColor: materialColor(item.name) }"
    >
      <v-img
        class="item-icon-img"
        max-height="24"
        max-width="24"
        width="24"
        height="24"
        contain
        :src="item.image_url"
      />
    </span>
    <span class="stat-label">{{ renameItem(item.name) }}</span>
    <v-spacer />
    <!-- Above 9,999, compact to thousands (e.g. 351,909 -> "351.9k") to keep the
         breakdown rows tidy; smaller counts show in full. -->
    <span class="stat-num">{{ formatCount(item.value, 10000) }}</span>
  </div>
</template>
<script>
import { materialColor } from "../utils/constants";
import { formatCount, renameItem } from "../utils/common";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCount,
    renameItem,
    materialColor,
  },
};
</script>
<style lang="scss" scoped>
.stat-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .stat-label {
    font-size: 15px;
    line-height: 1;
    margin: 0 4px;
  }
  .stat-num {
    font-size: 16px;
  }
}
// Coloured badge behind the item icon: background-color (set inline per item) is
// the item's material colour, so the icon acts as the pie's colour key.
.item-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  border-radius: 10px;

  // Force the (black, remote) icon to pure white so it reads on the dark badge:
  // brightness(0) flattens it to black, invert(1) then flips it to white. A CSS
  // filter isn't CORS-restricted the way mask-image is, so it works on the remote
  // image URLs.
  .item-icon-img {
    filter: brightness(0) invert(1);
  }
}
</style>
